import { CenteredFadeInSpinner, CenteredMessage } from '@tableau/data-catalog-shared';
import * as React from 'react';
import { Query } from 'react-apollo';
import { Messages } from '../../../gen-src/Localize';
import { LensQuery, LensQueryVariables, LensQuery_lenses } from '../../../gen-src/queries/LensQuery';
import { LensQueryGql } from '../../queries/LensQueryGql';
import { renderQueryResult } from '../renderQueryResult';
import { createRenderDataWithErrorFunction, renderError, renderNoData } from '../widgets/ErrorMessageWidgets';


export type LensQueryWrapperProps = Readonly<{
  vizportalUrlId: string;
  children: (result: LensQuery_lenses) => React.ReactNode;
}>;

export const LensQueryWrapper = (props: LensQueryWrapperProps): JSX.Element => {
  const renderLensData = (data: LensQuery): React.ReactNode => {
    const lens = data.lenses ? data.lenses[0] : null;
    return lens ? props.children(lens) : <CenteredMessage message={Messages.ErrorItemNotFound()} />
  }

  return <Query<LensQuery, LensQueryVariables>
    query={LensQueryGql}
    variables={{ vizportalUrlId: props.vizportalUrlId }}
  >{(result) => renderQueryResult(result, {
    renderLoading: CenteredFadeInSpinner,
    renderData: renderLensData,
    renderNoData: renderNoData,
    renderDataWithError: createRenderDataWithErrorFunction(renderLensData),
    renderError: renderError,
  })}</Query>;
}
